import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" {...props}><path fillRule="nonzero" d="M15.425 7L17 8.575l-1.313 1.312-1.575-1.575L15.425 7zm-.485 3.692l-5.593 5.59-2.1.529.525-2.105 5.592-5.589 1.576 1.575zM21 12a9 9 0 10-18 0 9 9 0 0018 0zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12z" /></svg>);